import DialogTermsContainer from './DialogTermsContainer';
export default DialogTermsContainer;
